import {SearchableItemService} from "../../../services/SearchableItemService";
import {textFilterParamsValues} from "../reactTableController";
import { booleanFilterParams, getBooleanValueGetter } from "../../utils/booleanColUtils";
export const defaultSortModel = [
    {
        colId: 'accountNumber',
        sort: 'asc',
        sortIndex: 1
    },
    {
        colId: 'closingDate',
        sort: 'desc',
        sortIndex: 0
    }
];
export const reactStatementsCols = function ( translate, userService) {
    const filterFormatter = userService.filterFormatter;
    return [ {
        field: "shortName",
        colId: 'shortName',
        headerName: translate.instant('ACCOUNT_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "accountNumber",
        headerName: translate.instant('ACCOUNT_NUMBER'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "openingDate",
        headerName: translate.instant('OPEN_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.openingDate) : "";
        }
    }, {
        field: "openingBalance",
        headerName: translate.instant('OPEN_BAL'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.openingBalance, 2) : "";
        },
        type: 'numericColumn'
    }, {
        field: "closingDate",
        headerName: translate.instant('CLOSE_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.closingDate) : "";
        }
    },{
        field: "closingBalance",
        headerName: translate.instant('CLOSE_BAL'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.closingBalance, 2) : "";
        },
        type: 'numericColumn'
    },{
        field: "statementNoOrig",
        headerName: translate.instant('STATEMENT_NUMB_ORIGINAL'),
        sortable: true,
        filter: 'agNumberColumnFilter'
    },{
        field: "f86Bank",
        headerName: translate.instant('INF_TO_ACCOWN'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "bank",
        headerName: translate.instant('BANK'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bank'])
                    .then(data => params.success(data.map(it => it.name)));
            }},
        initialHide: true
    }, {
        field: "bic",
        headerName: translate.instant('BIC'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bic'])
                    .then(data => params.success(data.map(it => it.code)));
            }},
        initialHide: true
    },{
        field: "country",
        headerName: translate.instant('COUNTRY'),
        sortable: true,
        filter:  "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['country'])
                    .then(data => params.success(data.map(it => it.name)));
            }},
        initialHide: true
    },{
        field: "currencyCode",
        headerName: translate.instant('CURRENCY'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['currency'])
                    .then(data => params.success(data.map(it => it.code)));
            }},
        initialHide: true
    },{
        field: "transactionRefNo",
        headerName: translate.instant('TRANS_REF'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues,
        initialHide: true
    },{
        field: "relatedReference",
        headerName: translate.instant('RELATED_REF'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues,
        initialHide: true
    },{
        field: "loadTime",
        headerName: translate.instant('RECEIVED_DATETIME'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateTimeNoLocal')( params.data.loadTime) : "";
        },
        initialHide: true
    }, {
        field: "stmtNoAll",
        headerName: translate.instant('STM_CALC_NUMBER1'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        headerTooltip: translate.instant('STM_CALC_NUMBER1_TOOLTIP'),
        initialHide: true
    }, {
        field: "stmtNoNED",
        headerName: translate.instant('STM_CALC_NUMBER2'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        headerTooltip: translate.instant('STM_CALC_NUMBER2_TOOLTIP'),
        initialHide: true
    }, {
        field: "stmtNoOldARS",
        headerName: translate.instant('STM_CALC_NUMBER3'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        headerTooltip: translate.instant('STM_CALC_NUMBER3_TOOLTIP'),
        initialHide: true
    }, {
        field: "camt053",
        headerName: translate.instant('CAMT053'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: booleanFilterParams('camt053', translate),
        valueGetter: getBooleanValueGetter('camt053', translate, data => data?.account?.camt053),
        initialHide: true
    }];
}
